import { render, staticRenderFns } from "./SuspensionScreen.vue?vue&type=template&id=d8634e74&scoped=true&"
import script from "./SuspensionScreen.vue?vue&type=script&lang=js&"
export * from "./SuspensionScreen.vue?vue&type=script&lang=js&"
import style0 from "./SuspensionScreen.vue?vue&type=style&index=0&id=d8634e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8634e74",
  null
  
)

export default component.exports